import Partners from "./Partners";
import { Layout } from "./utils";
import Subscribe from "./Subscribe";
import Footer from "./Footer";
import Security from "./Security";
import Info from "./Info";
import Hero from "./Hero";
import Ecosystem from "./Ecosystem";

const LandingPage = () => {
  return (
    <>
      <Layout>
        <Hero />
        <Info />
        <Ecosystem />
        <Security />
        <Partners />
        {/* <Blogs /> */}
        <Subscribe />
      </Layout>
      <Footer />
    </>
  );
};

export default LandingPage;
